module.exports = "/dist/4343d3d91a9446226e7a8bbb024111ad.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200.woff2
// module id = 113
// module chunks = 0